import Chart from 'chart.js';


export default class Doughnut {
    constructor() {
        this.percentage = parseInt($('.excuse__chart-container').data('success-percentage'), 10);
        this.remaining_percentage = 100 - this.percentage;
        this.ctx = document.getElementById('excuse__chart').getContext('2d');
        this.data = {
            datasets: [{
                data: [this.percentage, this.remaining_percentage],
                borderColor: 'transparent',
                backgroundColor: ['#e41c39', '#ffffff'],
            }],
        };
        this.options = {
            animation: {
                duration: 1200,
                animationScale: true,
                animationRotate: true,
                easing: 'easeOutQuart',
            },
            responsive: true,
            cutoutPercentage: 60,
            maintainAspectRatio: true,
            events: [],
            elements: {
                center: {
                    color: '#000',
                    fontStyle: '"Futura Plus W08 Medium", Arial, Sans-Serif',
                    text: `${this.percentage}%`,
                },
            },
        };

        this.constructor.registerPluginService();
        this.buildChart();
    }

    static registerPluginService() {
        Chart.pluginService.register({
            beforeDraw(chart) {
                if (chart.config.options.elements.center) {
                    const ctx = chart.chart.ctx;
                    const centerConfig = chart.config.options.elements.center;
                    const fontStyle = centerConfig.fontStyle || 'Arial';
                    const txt = centerConfig.text;
                    const color = centerConfig.color || '#000';
                    const sidePadding = centerConfig.sidePadding || 20;
                    const sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);

                    ctx.font = `2.9em ${fontStyle}`;

                    const stringWidth = ctx.measureText(txt).width;
                    const elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

                    const widthRatio = elementWidth / stringWidth;
                    const newFontSize = Math.floor(30 * widthRatio);
                    const elementHeight = (chart.innerRadius * 2);

                    const fontSizeToUse = Math.min(newFontSize, elementHeight);

                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
                    const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
                    ctx.font = `${fontSizeToUse}px ${fontStyle}`;
                    ctx.fillStyle = color;

                    ctx.fillText(txt, centerX, centerY);
                }
            },
        });
    }

    buildChart() {
        new Chart(this.ctx, {
            type: 'doughnut',
            data: this.data,
            options: this.options,
        });
    }
}



// WEBPACK FOOTER //
// ./frontend/js/modules/doughnut.js